import React from 'react';
import { TextField } from '@mui/material';

interface UpperCaseTextFieldProps {
  value: string;
  setValue: (value: string) => void;
  label: string;
  required: boolean;
  minLen?: number
}

const UpperCaseTextField: React.FC<UpperCaseTextFieldProps> = ({ value, setValue, label, required, minLen = 1 }) => {


  return (
    <TextField
      fullWidth
      label={label}
      type="text"
      size="small"
      required={required}
      value={value}
      onChange={e => setValue(e.target.value.toUpperCase())}
      slotProps={{
        htmlInput: {
          minLength: 3
        }
      }}
    />
  );
};

export default UpperCaseTextField;
